import {API_URL, apiPost} from '../api'

export const createTraderMapCampaign = async data => {
    return await apiPost(API_URL, 'admin/trader/campaign', data)
}
